import { useEffect, useRef, useCallback } from 'react';

const POLL_INTERVAL = 4 * 60 * 1000;

function getLoadedScriptSrc(): string | null {
  for (const s of Array.from(document.scripts)) {
    if (s.src && s.src.includes('/static/js/main')) return s.src;
  }
  return null;
}

async function fetchDeployedScriptSrc(): Promise<string | null> {
  try {
    const res = await fetch('/', {
      cache: 'no-store',
      headers: { 'Cache-Control': 'no-cache, no-store', Pragma: 'no-cache' },
    });
    const html = await res.text();
    const m = html.match(/src="(\/static\/js\/main[^"]+)"/);
    return m ? m[1] : null;
  } catch {
    return null;
  }
}

export function useVersionCheck(): void {
  const loaded = useRef<string | null>(null);
  const busy = useRef(false);

  useEffect(() => {
    loaded.current = getLoadedScriptSrc();
  }, []);

  const check = useCallback(async () => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('mode') === 'gestor') return;
    if (busy.current || !loaded.current) return;
    busy.current = true;
    try {
      const deployed = await fetchDeployedScriptSrc();
      if (deployed && deployed !== loaded.current) {
        window.location.reload();
      }
    } finally {
      busy.current = false;
    }
  }, []);

  useEffect(() => {
    const id = setInterval(check, POLL_INTERVAL);
    window.addEventListener('focus', check);
    return () => {
      clearInterval(id);
      window.removeEventListener('focus', check);
    };
  }, [check]);
}
